import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import apiClient from '../../api/axios';
import { toast } from 'react-toastify';

export const useAuthApi = () => {
    const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();

    // Only send email and password
    const login = async (email, password) => {
        try {
            setLoading(true);
            const payload = { email, password };
            const response = await apiClient.post('/login-dashboard', payload);
            
            if (response.data.success) {
                const userData = response.data.data.user;
                // Validate role
                if (!['vendor', 'admin', 'employee'].includes(userData.role)) {
                    return {
                        success: false,
                        message: 'Unknown user role'
                    };
                }
                // Set user data in the cache
                queryClient.setQueryData(['authUser'], userData);
                return {
                    success: true,
                    data: {
                        user: userData
                    }
                };
            } else {
                return {
                    success: false,
                    message: response.data.message || 'Login failed'
                };
            }
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Login failed';
            return {
                success: false,
                message: errorMessage
            };
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        try {
            await apiClient.post('/logout');
            toast.success('Logged out successfully');
            // Clear the cache on logout
            queryClient.clear();
            return { success: true };
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error during logout';
            toast.error(errorMessage);
            // Still clear cache even if API fails
            queryClient.clear();
            return {
                success: false,
                message: errorMessage
            };
        }
    };

    return { login, logout, loading };
};